import React from "react";
import styles from "./styles/About.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import AboutHero from "./AboutHero";
import OurStory from "./OurStory";
import PartnerStats from "./PartnerStats";
import VisionMission from "./VisionMission";
import CoreValues from "./CoreValues";

export default function About() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <AboutHero />
        <OurStory />
        <PartnerStats />
        <VisionMission />
        <CoreValues />
      </main>
      <Footer />
    </div>
  );
}
